import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clean-ico",
  "use": "icon-clean-ico-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 12\" id=\"icon-clean-ico\">\r\n<style type=\"text/css\">\r\n\t#icon-clean-ico .st0{fill:#394043;}\r\n</style>\r\n<path class=\"st0\" d=\"M13.6,4.7c0.2-0.2,0.2-0.4,0-0.6l-4-3.9C9.3,0,9.1,0,8.9,0.1L0.4,8.9C0.3,9,0.3,9.3,0.4,9.5l1.7,1.7L3,12h3.8\r\n\tL7,11.6v-0.5L6.9,12L13.6,4.7L13.6,4.7z M1.3,9.2l4.2-4.4l3.6,3.4l-2.8,3l-3,0L1.3,9.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol